import React from 'react';
import HeroSection from './HeroSection';
import Card from './Card';
import CardSection from './CardSection';
import AppSection from './AppSection';

export default function Home(){
    return (
        <>
        <HeroSection/> 
        <AppSection/>
        <CardSection/>
        </>
    );
};